module.exports = __webpack_public_path__ + "img/cancel-blue.b8062799.svg";